import { render, staticRenderFns } from "./checkbox-item.vue?vue&type=template&id=13159238&scoped=true&"
import script from "./checkbox-item.vue?vue&type=script&lang=js&"
export * from "./checkbox-item.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-item.vue?vue&type=style&index=0&id=13159238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13159238",
  null
  
)

export default component.exports